export default "__VITE_ASSET__CqZINF7m__"